<!--
 * @Author: qixiao
 * @Date: 2022-09-06 17:24:16
 * @LastEditTime: 2022-09-23 18:27:16
 * @LastEditors: liushumin
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="Enter_top">
        <div class="block" v-if="logoImg.length > 0">
          <el-image style="width: 160px; height: 80px" :src="logoImg[0]"></el-image>
        </div>
        <div class="block" v-else>
          <el-image style="width: 160px; height: 80px" :src="supplierImg"></el-image>
        </div>
        <div class="Enter_top_text">
          <p class="fs18">{{ list.enterpriseName }}</p>
          <p class="fs888">
            <i class="iconfont icon-xinyongdaima"></i>统一社会信用代码：{{
            list.orgCode
            }}
          </p>
        </div>
      </div>
      <div class="plate">
        <div class="title">基本信息</div>
      </div>
      <div class="Enter_message" style="margin-top: 20px">
        <el-descriptions class="margin-top" title="" :column="3" border>
          <el-descriptions-item label-class-name="business_css">
            <template slot="label"> 法人代表 </template>
            {{ list.orgLegalPerson }}
          </el-descriptions-item>
          <el-descriptions-item label-class-name="business_css">
            <template slot="label"> 所在地区 </template>
            {{ list.pname }}{{ list.cname }}{{ list.oname }}
          </el-descriptions-item>
          <el-descriptions-item label-class-name="business_css">
            <template slot="label"> 注册地址 </template>
            {{ list.registAddr }}
          </el-descriptions-item>
          <el-descriptions-item label-class-name="business_css">
            <template slot="label"> 成立日期 </template>
            {{ list.registTime }}
          </el-descriptions-item>
          <el-descriptions-item label-class-name="business_css">
            <template slot="label"> 注册资本 </template>
            {{ list.registCapital }}
          </el-descriptions-item>
          <el-descriptions-item label-class-name="business_css">
            <template slot="label"> 营业期限 </template>
            {{ list.businessTerm || "长期" }}
          </el-descriptions-item>
          <el-descriptions-item label-class-name="business_css">
            <template slot="label"> 营业范围 </template>
            {{ list.scopes }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions id="yyzz2" style="margin-top: 0px" class="margin-top" title="" :column="3" border>
          <el-descriptions-item label-class-name="business_css">
            <template slot="label"> 营业执照 </template>
            <div class="imgarr" style="margin-top: 20px">
              <div class="demo-image__preview">
                <el-image v-for="item in srcList" style="width: 100px; height: 100px" :src="item.imgUrl"
                  :preview-src-list="srcListImages" v-show="item.types == 10">
                </el-image>
              </div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label-class-name="business_css">
            <template slot="label"> 生产/销售许可证 </template>
            <div class="imgarr" style="margin-top: 20px">
              <div class="demo-image__preview">
                <el-image v-for="item in srcList" style="width: 100px; height: 100px" :src="item.imgUrl"
                  :preview-src-list="srcListImages" v-show="item.types == 20 ">
                </el-image>
              </div>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="Enter_userMessage">
        <div class="plate">
          <div class="title2">发货信息</div>
          <div class="title2">联系人信息</div>
          <el-descriptions style="width: 49%; display: inline-block" class="margin-top" title="" :column="3" border>
            <el-descriptions-item label-class-name="business_css">
              <template slot="label"> 商品发货地 </template>
              {{ list.addr }}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions style="width: 49.5%; display: inline-block; margin-left: 16px" class="margin-top" title=""
            :column="2" border>
            <el-descriptions-item label-class-name="business_css">
              <template slot="label"> 联系人 </template>
              {{ list.linkPerson }}
            </el-descriptions-item>
            <el-descriptions-item label-class-name="business_css">
              <template slot="label"> 联系人电话 </template>
              {{ list.linkPhone }}
            </el-descriptions-item>
          </el-descriptions>
          <div class="title mt20">账户信息</div>
          <div class="userDetail">
            <el-descriptions style="margin-top: 20px" class="margin-top" direction="vertical" title="" :column="4"
              border>
              <el-descriptions-item>
                <template slot="label"> 账户名称 </template>
                {{ yhkh.accountName }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 银行账号 </template>
                {{ yhkh.accountNo }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 开户行 </template>
                {{ yhkh.bankName }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 开户行卡号 </template>
                {{ yhkh.bankNo }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      ids: this.$route.query.ids,
      //图片路径
      url: "",

      srcList: [
      ],

      // 表格部分
      size: "",
      list: [],
      yhkh: {},
      srcListImages: [],
      supplierImg: "",
      logoImg: [],
      // scImage: []
    };
  },
  mounted() { },
  created() {
    this.fn();
  },
  methods: {
    fn() {
      console.log(this.ids);
      this.$http.supplierApi.getSupplierDetail({ id: this.ids }).then((res) => {
        console.log(res);
        this.list = res.data;
        this.srcList = res.data.szProductsMediaList;
        console.log(this.srcList);
        this.srcListImages = [];
        this.yhkh = res.data.szEnterpriseAccount[0];

        res.data.szProductsMediaList.forEach((item) => {
          if (item.types == 30 && item.flag == 10) {
            this.logoImg.push(item.imgUrl);
          } else {
            this.logoImg = [];
          }

        });

        if (this.logoImg.length > 0) {
          this.supplierImg = this.logoImg.join(",");
        } else {
          this.supplierImg = "";
        }
      });
    },
  },
};
</script>
<style lang="scss">
.business_css {
  width: 150px;
}
</style>
<style lang="scss" scoped>
.Enter_top {
  width: 100%;
  height: 80px;
  display: flex;

  .Enter_top_text {
    margin-left: 17px;

    // width: 80%;
    p:nth-child(1) {
      height: 50px;
      line-height: 50px;
    }
  }
}

.el-image {
  margin-right: 10px;
}

.plate {
  margin-top: 20px;
  // padding: 10px 20px;

  .title {
    font-size: 18px;
    color: #018388;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;

    label {
      font-size: 16px;
      color: #999999;
    }

    &:before {
      content: "";
      display: inline-block;
      width: 5px;
      height: 18px;
      background: #018388;
      border-radius: 3px;
      margin-right: 5px;
    }
  }

  .title2 {
    font-size: 18px;
    color: #018388;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;
    width: 50%;
    display: inline-block;

    label {
      font-size: 16px;
      color: #999999;
    }

    &:before {
      content: "";
      display: inline-block;
      width: 5px;
      height: 18px;
      background: #018388;
      border-radius: 3px;
      margin-right: 5px;
    }
  }
}

::v-deep .el-descriptions-item__label.is-bordered-label {
  background: #f5f8fa;
  text-align: right;
}

::v-deep .is-bordered-label {
  text-align: right;
}

::v-deep #yyzz2 .el-descriptions-item__cell {
  border-top: none;
}

::v-deep .userDetail .is-bordered-label {
  text-align: center;
}

::v-deep .userDetail .el-descriptions-item__cell {
  text-align: center;
}

.el-descriptions-item__cell .fs18 {
  font-size: 24px;
  font-weight: bold;
  color: #333333;
  font-weight: bold;
}

.fs888 {
  color: #888;
  font-size: 18px;
  font-weight: 400;
}

.mt20 {
  margin-top: 20px;
}

.block {
  width: 160px;
}

.icon-xinyongdaima {
  font-size: 20px;
  margin-right: 5px;
}
</style>
